import { useQuery } from '@tanstack/react-query'
import apiClient from '../api/client'

// ---------------------------------------------------------------------------
// Feature flag di agenzia (GET /api/agency/features).
// Fail-open di proposito: a query ancora in corso o fallita ogni funzionalità
// risulta abilitata, così un backend vecchio o un errore di rete non nasconde
// mai voci di menu esistenti.
// ---------------------------------------------------------------------------

export function useEnabledFeatures() {
  const { data, isLoading, isError } = useQuery<string[]>({
    queryKey: ['agency', 'features'],
    queryFn: async () => {
      const res = await apiClient.get('/agency/features')
      return res.data
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })

  const isEnabled = (name: string): boolean => {
    if (!data) return true
    return data.some((f) => f.toLowerCase() === name.toLowerCase())
  }

  return { features: data, isLoading, isError, isEnabled }
}
